import { Navigate, Outlet } from 'react-router-dom';

/**
 * Route guard: chỉ cho phép truy cập nếu đã đăng nhập với vai trò giám thị.
 * Token được lưu dưới key `giam_thi_token`.
 */
export default function RequireGiamThi() {
    const token = localStorage.getItem('giam_thi_token');
    if (!token) {
        return <Navigate to="/giam-sat-thi/login" replace />;
    }
    return <Outlet />;
}
